export const isCacheableFind = (config) => {
    const { filters, hydratedFields } = config;
    return (filters?.fields || filters?.where) && !filters?.paging && !hydratedFields?.length;
};
//# sourceMappingURL=isCacheableFind.js.map